import { Typography } from "@mui/material";

export function AssistantMessageLoading() {
  return (
    <Typography className="animate-pulse">
      Generating{" "}
      <span className="loading-dots">
        <span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </span>
    </Typography>
  );
}
